<script>
  import Tournament from '@/pc/pages/Tournament'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Tournament,
    components: {
      PageLayout, DisplayContainer
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .tnmt_detail .detail_con .tnmt_box h3 {
    font-size: 30px;
    line-height: 1.1em;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
  }
  .tnmt_detail .detail_con .tnmt_box h5 {
    font-size: 18px;
    padding: 20px 0 15px;
  }
  .tnmt_detail .detail_con .tnmt_box h6 {
    font-size: 15px;
    font-weight: 600;
    color: rgba(255,255,255,0.70);
    padding: 0 0 8px 0;
    position: relative;
    z-index: 2;
  }
  .tnmt_detail .detail_con .tnmt_box {
    width: 100vw;
    margin-top: 25px;
    margin-left: -15px;
  }
  .tnmt_detail .detail_con .tnmt_box .venue_wrap {
    padding: 170px 15px 40px;
  }
  .tnmt_detail .detail_con .tnmt_box .venue {
    height: 96vw;
  }
  .tnmt_detail .detail_con .tnmt_box .venue:after {
    height: 85vw;
    background: linear-gradient(0deg, rgba(0, 0, 0, 1.0) 10%, rgba(0, 0, 0, 0.0));
  }
  .tnmt_detail .detail_con .tnmt_box .venue .img {
    height: 100%;
  }
  .tnmt_detail .detail_con .tnmt_box .venue .img img {
    object-fit: cover;
    height: 100%;
  }
  .tnmt_detail .detail_con .tnmt_box:before {
    background: none;
  }
  .tnmt_detail .detail_con .tnmt_box:after {
    
  }
  .tnmt_detail .detail_con .tnmt_box ul.detail {
    width: 100%;
  }
  .tnmt_detail .detail_con .tnmt_box ul.detail > div {
    margin-bottom: 10px;
  }
  .tnmt_detail .detail_con .tnmt_box ul.logo {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    background: #000;
  }
  .tnmt_detail .detail_con .tnmt_box ul.logo .img img {
    width: 100%;
    height: 100%;
  }
  .tnmt_detail .detail_con .tnmt_box .detail {
    font-size: 15px;
    font-weight: 300;
    text-align: center;
  }
  .tnmt_detail .detail_con .tnmt_box .detail li {
    line-height: 1.7em;
    margin-bottom: 15px;
    text-align: left;
  }
  .tnmt_detail .detail_con .tnmt_box ul.detail p span {
    font-size: 15px !important;
  }
  .tnmt_detail .detail_con .tnmt_box ul.detail p:first-child span {
    font-size: 18px !important;
  }
  .tnmt_detail .detail_con .tnmt_box .detail li span:after {
    content: "";
    padding-left: 0;
  }
  .tnmt_detail .detail_con .tnmt_box .detail li i {
    display: block;
    padding-left: 0;
  }
  .tnmt_detail .detail_con .tnmt_box .detail .btn_view {
    font-size: 0.9em;
    font-weight: 800;
    padding: 15px;
    width: 100%;
    margin: 2px 0;
  }
  .tnmt_detail .detail_con .tnmt_box .detail .btn_view:hover {
    background: #92ffbd;
  }
  .tnmt_detail .detail_con .tnmt_box .detail .item-title {
    font-size: 18px;
    padding: 9px 18px;
  }
  .tnmt_detail .detail_con .tnmt_box .detail .item-title:before {
    width: 24px;
    height: 24px;
  }
  .tnmt_detail .detail_con .info_wrap {
    margin: 0;
  }
  .tnmt_detail .detail_con .info_wrap .info {
    padding: 0 15px 30px;
    position: relative;
  }
  .tnmt_detail .detail_con .info_wrap .info p {
    font-size: 12.5px;
    color: rgba(255,255,255,0.85);
    line-height: 1.6em;
    padding-left: 23px;
  }
  .tnmt_detail .detail_con .info_wrap .info p span {
    display: block;
  }
  .tnmt_detail .detail_con .info_wrap .info p:before {
    position: absolute;
    margin-top: 0.2em;
    left: 17px;
    font-size: 0.8em;
    width: 14px;
    height: 14px;
  }
  
  /* 신규 콘텐츠 202504 */
  .tnmt_detail .detail_con .con_series {
    margin-top: 30px;
    margin: 0 15px;
  }
  .tnmt_detail .detail_con .con_series .section {
    padding: 27px 20px;
    margin-bottom: 15px;
    background: rgba(255,255,255,0.098);
    backdrop-filter: blur(8px);
  }
  .tnmt_detail .detail_con .con_series .section .title {
    font-size: 19px;
    margin-bottom: 24px;
    height: unset;
    letter-spacing: -0.02em;
  }
  .tnmt_detail .detail_con .con_series .section .title:before {
    width: 21px;
    height: 21px;
    margin-right: 10px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_rep {
    display: inline-block;
    background: none;
    border-radius: 0;
    padding: 17px 0;
    margin-bottom: 0;
    border-bottom: 1px solid #333;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_rep:nth-child(2) {
    padding-top: 0;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_rep:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_rep .event {
    display: block;
    width: 100%;
    font-size: 16px;
    line-height: 1.2em;
    margin-top: 5px;
    margin-left: 2px;
    margin-bottom: 12px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_rep a.rep {
    display: inline-block;
    font-size: 15px;
    padding: 10px 14px;
    margin: 4px 2px;
  }
  .tnmt_detail .detail_con .con_series .section .sect_wrap {
    position: relative;
    width: calc(100vw - 30px);
    height: unset !important;
    left: -20px;
    padding: 0 20px;
    white-space: nowrap;
    overflow-x: scroll !important;
  }
  .tnmt_detail .detail_con .con_series .section .sect_wrap > * {
    white-space: normal;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_news {
    width: 62vw !important;
    margin-right: 16px;
    margin-bottom: 0;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_news:nth-child(4n) {
    margin-right: 16px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_news:nth-child(n+9) {
    display: inline-block;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_news .img {
    height: 44vw;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_news .cate {
    font-size: 13px;
    padding: 0 2px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_news .subj {
    font-size: 15.5px;
    padding: 0 2px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_gallery {
    width: 62vw;
    height: 96vw;
    margin-right: 16px;
    margin-bottom: 0;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_gallery:nth-child(4n) {
    margin-right: 16px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_gallery .img:after {
    background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.95));
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_gallery .subj {
    left: 20px;
    bottom: 43px;
    padding-right: 20px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_gallery .count {
    font-size: 13px;
    left: 20px;
    bottom: 20px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_info {
    width: 62vw;
    height: 62vw;
    margin-right: 16px;
    margin-bottom: 0;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_info:nth-child(4n) {
    margin-right: 16px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre {
    display: inline-block;
    background: none;
    border-radius: 0;
    padding: 24px 20px 26px 0;
    margin-bottom: 0;
    border-bottom: 1px solid #333;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre:nth-child(2) {
    padding-top: ;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre:last-child {
    padding-bottom: ;
    border-bottom: none;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre:last-child {
    margin-bottom: 0;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre:after {
    width: 6px;
    height: 6px;
    border-width: 2px 2px 0 0;
    right: 2px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre p {
    display: inline-block;
    font-size: 13px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre .series {
    width: 100%;
    font-size: 16px;
    margin-bottom: 12px;
    padding-right: 10px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre .flag {
    width: unset;
    margin-right: 12px;
    margin-top: -1.5px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre .flag img {
    height: 16px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre .date {
    width: unset;
    margin-right: 16px;
  }
  .tnmt_detail .detail_con .con_series .section .ctnr_pre:hover {
    background: unset;
  }
  .tnmt_detail .detail_con .con_series .section.pre {
    padding-bottom: 10px;
  }
  .tnmt_detail .detail_con .con_series .section.pre .title {
    margin-bottom: 5px;
  }
  .market_pop {
    max-height: unset !important;
    height: 100vw !important;
  }
  .market_pop .close_btn {
		top: 10px !important;
		right: 10px !important;
	}
  .market_pop .img {
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100vw !important;
    height: 100vw !important;
  }
  
  .tnmt_detail .detail_con .sche-table {
    width: 100%;
    display: block;
    padding: 0 !important;
  }
  .tnmt_detail .detail_con .sche-table .caption {
    display: none;
  }
  .tnmt_detail .detail_con .sche-table tr {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-bottom: 3px solid rgba(0,0,0,0.75);
    padding: 10px 5px;
  }
  .tnmt_detail .detail_con .sche-table tr:last-child {
    border-bottom: 0;
  }
  .tnmt_detail .detail_con .sche-table tr:nth-child(odd) {
    background: unset;
  }
  .tnmt_detail .detail_con .sche-table tr:hover:after {
    border: 0;
  }
  .tnmt_detail .detail_con .sche-table tr.on:after {
    border: 0;
  }
  .detail_con .sche-table tr.red {
    background: linear-gradient(to right, rgba(255,0,150,0.0), rgba(255,0,150,0.55)) !important;
  }
  .detail_con .sche-table tr.blue {
    background: linear-gradient(to right, rgba(0,150,255,0.0), rgba(0,150,255,0.55)) !important;
  }
  .detail_con .sche-table tr.green {
    background: linear-gradient(to right, rgba(0,255,100,0.0), rgba(0,255,100,0.35)) !important;
  }
  .tnmt_detail .detail_con .sche-table td {
    display: inline-flex;
    padding: 10px !important;
    font-size: 0.8em;
  }
  .tnmt_detail .detail_con .sche-table td.date {
    /*flex-basis: 100%;*/
    order: -2;
    font-size: 0.9em;
    font-weight: 800;
    color: #fff;
    padding: 7px 10px !important;
    background: rgba(255,255,255,0.2);
    border-radius: 0.2em;
    display: inline-block;
    width: 100%;
    text-align: center;
    min-width: unset;
    transform: translate(0, -5px);
  }
  .tnmt_detail .detail_con .sche-table td.date:after {
    background: none;
  }
  .tnmt_detail .detail_con .sche-table td.name {
    flex-basis: 100%;
    margin: 0;
    width: 100%;
    order: -1;
    background: unset !important;
  }
  .tnmt_detail .detail_con .sche-table td.name p,
  .tnmt_detail .detail_con .sche-table td.name span {
    display: block;
    width: 100%;
    font-size: 1.25em;
    padding-right: 10px;
  }
  .tnmt_detail .detail_con .sche-table td.name p em {
    font-size: 0.9em;
  }
  .tnmt_detail .detail_con .sche-table td.name p:after{
    right: 0;
  }
  .tnmt_detail .detail_con .sche-table td.hide_usd {
    display: inline-flex;
    visibility: hidden;
  }
  .tnmt_detail .detail_con .sche-table tr.on td.name {
    flex-direction: column;
    font-size: 1.05em;
    font-weight: 800;
    line-height: 1.35em;
  }
  .tnmt_detail .detail_con .sche-table tr.on td.name em {
    font-size: 0.7em;
  }
  .tnmt_detail .detail_con .sche-table td.name .detail {
    font-size: 11px;
    padding-left: 0;
    line-height: 2.0em;
  }
  .tnmt_detail .detail_con .sche-table td.name .detail .btn_view_detail {
    font-size: 1.3em;
    font-weight: 800;
    padding: 12px 40px 12px 18px;
    width: 100%;
  }
  .tnmt_detail .detail_con .sche-table td.time {
    flex-basis: 50%;
    padding-top: 2px !important;
    padding-bottom: 0 !important;
    color: rgba(0,160,140,0.9);
    font-weight: 800;
  }
  .tnmt_detail .detail_con .sche-table td.time:before {
    content: "Time";
    padding-right: 5px;
    font-weight: 500;
  }
  .tnmt_detail .detail_con .sche-table td.buyin {
    flex-basis: 50%;
    justify-content: flex-end;
    padding-top: 2px !important;
    padding-bottom: 0 !important;
    color: rgba(255,255,255,0.65);
    font-weight: 800;
  }
  .tnmt_detail .detail_con .sche-table td.buyin:before {
    content: "Buy-in";
    padding-right: 5px;
    font-weight: 500;
  }
  .tnmt_detail .detail_con .sche-table td.usd {
    flex-basis: 40%;
    padding-top: 2px !important;
    padding-bottom: 0 !important;
    justify-content: flex-end;
    order: 4;
  }
  .tnmt_detail .detail_con .sche-table td.usd:before {
    content: "USD";
    padding-right: 5px;
    font-weight: 100;
  }
  .tnmt_detail .detail_con .sche-table td.stack,
  .tnmt_detail .detail_con .sche-table td.clock {
    padding-top: 2px !important;
    padding-right: 0 !important;
    padding-left: 5px !important;
    order: 5;
  }
  .tnmt_detail .detail_con .sche-table td.stack {
    padding-left: 10px !important;
  }
  .tnmt_detail .detail_con .sche-table td.clock {
    
  }
  .tnmt_detail .detail_con .sche-table td.stack:before {
    content: "Stack";
    padding-right: 5px;
    font-weight: 100;
  }
  .tnmt_detail .detail_con .sche-table td.clock:before {
    content: "/ Clock";
    padding-right: 5px;
    font-weight: 100;
  }
  .tnmt_detail .detail_con .sche-table td.late-reg {
    flex-basis: 60%;
    padding-top: 2px !important;
    padding-bottom: 0 !important;
    order: 3;
  }
  .tnmt_detail .detail_con .sche-table td.late-reg:before {
    content: "Late Reg";
    padding-right: 5px;
    font-weight: 100;
  }
  /*.tnmt_detail .detail_con .sche-table tr:nth-child(3) {
    background: linear-gradient(to right, rgba(0,255,100,0.0), rgba(0,255,100,0.35));
  }
  .tnmt_detail .detail_con .sche-table tr:nth-child(5) .name {
    color: rgba(0,255,100,1.0);
  }
  .tnmt_detail .detail_con .sche-table tr:nth-child(7) {
    background: linear-gradient(to right, rgba(0,110,255,0.0), rgba(0,110,255,0.55));
  }
  .tnmt_detail .detail_con .sche-table tr:nth-child(9) {
    background: linear-gradient(to right, rgba(255,0,140,0.0), rgba(255,0,110,0.55));
  }*/
  .tnmt_detail .detail_con .schedule {
    margin-top: 40px;
  }
  .tnmt_detail .detail_con .schedule h3 {
    font-size: 19px;
    font-weight: 700;
    text-align: center;
  }
  .tnmt_detail .detail_con .schedule .lst dl {
    width: 100vw;
    margin-left: -20px;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt {
    padding: 22px 10px;
    max-height: 85px;
    letter-spacing: -0.03em;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt:hover {

  }
  .tnmt_detail .detail_con .schedule .lst dl.on dt {

  }
  .tnmt_detail .detail_con .schedule .lst dl dt p {
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    letter-spacing: -0.03em;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt p:nth-child(1) {
    flex-basis: 15%;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt p:nth-child(2) {
    display: none;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt p:nth-child(3) {
    flex-basis: 58%;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt p:nth-child(4) {
    flex-basis: 17%;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt p:nth-child(5) {
    flex-basis: 10%;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt p.name {
    font-weight: 700;
    width: unset;
    margin: 0;
  }
  .tnmt_detail .detail_con .schedule .lst dl dt:after {
    right: 5%;
    width: 14px;
    height: 12px;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box {
    padding: 20px;
    font-size: 14px;
    font-weight: 400;
    word-break: break-all;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box p {
    padding: 4px 0;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box .btn_view {
    font-size: 0.9em;
    font-weight: 800;
    padding: 15px 40px 15px 18px;
    margin: 2px 0;
    width: 100%;
    background: #f5f5f5;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box div:first-child {
    margin-bottom: 15px;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box table {
    width: calc(100vw - 40px) !important;
    white-space: nowrap;
    overflow-x: scroll;
    display: block;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box table tbody {
    display: table;
    width: 100%;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box table td {
    padding: 8px 2.0vw;
    font-size: 0.85em;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box table td:first-child {
    padding-left: 4vw;
  }
  .tnmt_detail .detail_con .schedule .lst dl dd .in_box table td:last-child {
    padding-right: 4vw;
  }
  .tnmt_detail .detail_con p[data-f-id='pbf'] { 
    display: none !important;
  }
  .p-hide {
    display: inline-block !important;
  }
</style>
